module.exports = __webpack_public_path__ + "img/search.898ea790.svg";